export { default as createSvgIcon } from './createSvgIcon';
